import React from "react";

interface NotFoundListProps {
  image?: string;
  title: string;
  description: string;
  renderButton?: () => React.ReactNode;
}

const NotFoundList: React.FC<NotFoundListProps> = ({ image='/assets/images/not-found.webp', title, description ,renderButton}) => {
  return (
    <div className="flex flex-col items-center justify-center h-full py-16">
      <img src={image} alt="not found" width={160} height={160} className="w-40 h-40 object-contain mb-6 opacity-80" />
      <h2 className="text-2xl text-white font-bold mb-2 text-center">{title}</h2>
      <p className="text-base text-gray-400 text-center max-w-xs">{description}</p>
        {renderButton && (
            <div className="mt-4">
            {renderButton()}
            </div>
        )}
    </div>
  );
};

export default NotFoundList;
